import React from "react";
import Carousel from "./Carousel";

const Features = ({ isMobile }) => {
  return (
    <div className="features">
      <div className="features__header">
        <div className="features__header--heading">
        An App which is specially designed for your teaching business
        </div>
        <div className="features__header--content">
          Our mission is to bring each utility needed by you to grow bigger and
          faster, on one single platform.
        </div>
      </div>
      <div className="features__content">
        <Carousel isMobile={isMobile} />
      </div>
    </div>
  );
};

export default Features;
